import { registerCollisionAnimation } from './CollisionAnimationRegistry';
import { QuantumLeapAnimation } from '../blasts/QuantumLeap';

registerCollisionAnimation('QUANTUM_TUNNEL', (ctx, e, config, progress) => {
  QuantumLeapAnimation(ctx, e as any, config, progress);
});
